export const timeStampExp = /^(([0-9][0-9]:)?([0-5][0-9]|[6][0]):[0-5][0-9])$/;

export const urlExp =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

export const emailRegExp =
  /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const phoneCharactersRegExp = /^[0-9()+ -]*$/;

export const zipCodeRegExp = /^[0-9]{5}(?:-[0-9]{4})?$/;

export const dashedWordRegExp = /^[a-zA-Z0-9-]*$/;

export const lettersSpacesAndHyphenRegExp = /^[A-Za-z\s\-\']+$/;

export const passwordStrengthRegExp = new RegExp(
  '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])'
);

export const phoneNumberFormatRegExp = /^(?:\(\d{3}\)|\d{3}-)\s\d{3}-\d{4}$/;

export const addressFormatRegExp = /^[\w\s.-]+$/i;

export const apostropheRegExp = /^[^.\s\-\']*$/;

// supports international name characters too
export const nameRegExp =
  /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u;
